import classNames from "classnames";
import { Inter } from "next/font/google";

const interFont = Inter({ subsets: ["latin"] });

export const TertiaryTitle = ({ children, className }) => {
	return (
		<div
			className={classNames(
				interFont.className,
				"text-2xl font-semibold leading-loose",
				"w-80 text-[#001c3d]",
				className
			)}>
			{children}
		</div>
	);
};
